import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import CmsCouponMenuLinksImpl from './cms-coupon-menu-links.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that renders a sticky CMS coupon menu for homepage navigation.
 *
 * @class CmsCouponMenuLinks
 * @memberof Mojito.Modules
 */

/**
 * CmsCouponMenuLinks prop types.
 *
 * @property {string} couponsListId - CMS coupons list id.
 * @property {boolean} [showPrimaryTopSportsTab = false] - Whether to show the primary top sports anchor tab.
 * @property {boolean} [showSecondaryTopSportsTab = false] - Whether to show the secondary top sports anchor tab.
 * @property {string} [primaryTopSportsTabLabel = ''] - Label for the primary top sports anchor tab.
 * @property {string} [secondaryTopSportsTabLabel = ''] - Label for the secondary top sports anchor tab.
 * @property {Function} [onItemClick] - Called when a menu item is clicked so the page can prepare deferred section content before scrolling.
 *
 * @memberof Mojito.Modules.CmsCouponMenuLinks
 */
const propTypes = {
    couponsListId: PropTypes.string.isRequired,
    showPrimaryTopSportsTab: PropTypes.bool,
    showSecondaryTopSportsTab: PropTypes.bool,
    primaryTopSportsTabLabel: PropTypes.string,
    secondaryTopSportsTabLabel: PropTypes.string,
    onItemClick: PropTypes.func,
};

const defaultProps = {
    showPrimaryTopSportsTab: false,
    showSecondaryTopSportsTab: false,
};

export default UIView('CmsCouponMenuLinks', CmsCouponMenuLinksImpl, propTypes, defaultProps);
